import { Validators, ValidatorFn } from '@angular/forms';
import * as _ from 'lodash';

export class CampoFormulario
{
    readonly name?: string;
    readonly placeHolder?: string;
    readonly required?: boolean;
    readonly email?: boolean;
    readonly minLength?: number;
    readonly maxLength?: number;
    getValidators? = (extraValidators?: Array<ValidatorFn>) => Array<ValidatorFn>();

    constructor(o: CampoFormulario = {} as CampoFormulario)
    {
        this.name = o.name || undefined;
        this.placeHolder = o.placeHolder || undefined;
        this.required = o.required || false;
        this.minLength = o.minLength || undefined;
        this.maxLength = o.maxLength || undefined;
        this.getValidators = (extraValidators?: Array<ValidatorFn>) =>
        {
            const validators = new Array<ValidatorFn>();
            _.forOwn(this, function(value, key)
            {
                if (value)
                {
                    switch (key)
                    {
                        case 'required': validators.push(Validators.required); break;
                        case 'minLength': validators.push(Validators.minLength(value)); break;
                        case 'maxLength': validators.push(Validators.maxLength(value)); break;
                        case 'email': validators.push(Validators.email); break;
                        default: break;
                    }
                }
            });
            if (extraValidators != null)
            {
                validators.push(...extraValidators);
            }
            return validators;
        };
    }
}